import styled from 'styled-components';

const StyledLink = styled.a`
    display: block;
    text-decoration: none;
    color: #000000;
    line-height: 1.5;
    margin-bottom: 12px;

    &:hover {
        cursor: pointer;
        color: blue;
    }
`;

const PageRow = styled.div`
    margin: 64px 0;
`;

const SocialRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 36px;
`;

const ContactRow = styled.div`
    opacity: .6;
    margin-bottom: 54px;
`;

const TitleUnderline = styled.div`
    border-bottom: solid 1px;
    margin-bottom: 36px;
`;

const LightText = styled.div`
    font-family: Overpass;
`;

const SocialLink = styled.a`
    display: flex;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    color: #000000;

    &:hover {
        color: blue;
        & > img {
            filter: none;
        }
    }
    
    & > img {
        height: 18px;
        filter: brightness(0);
    }

    & > span {
        margin-left: 12px;
        display: none;

        @media screen and (min-width: 1024px){
            display: inline-block;
        }
    }

`;

export { StyledLink, PageRow, SocialRow, ContactRow, TitleUnderline, LightText, SocialLink };